<template>
	<div class="main_page r_email_page" ref="middle_page">
		<span class="r_email_page_filter"></span>
		<div class="r_email_content">
			<div class="r_email_box">
				<div class="logo_font">
					<p>{{$t('register_email.title')}}</p>
				</div>
				<div class="email_img">
					<img src="static/images/envelope.png">
				</div>
				<div class="email_right">
					<p>{{$t('register_email.message')}}</p>
					<!--<p v-if="this.$route.query.activatePurpose == 0">{{$t('register_email.validation')}}</p>
					<p v-if="this.$route.query.activatePurpose == 0">{{$t('register_email.us')}}{{this.$route.query.email}}{{$t('register_email.send')}}</p>
					<p v-if="this.$route.query.activatePurpose == 1">{{$t('register_email.login')}}</p>
					<p v-if="this.$route.query.activatePurpose == 1">{{$t('register_email.us')}}{{this.$route.query.email}}{{$t('register_email.reset')}}</p>
					<button class="cursor">立即激活</button>
					<p></p>
					<p>{{$t('register_email.receive')}}</p>
					<p>1.{{$t('register_email.leftClick')}}<ins @click="resendMail()" style="cursor:pointer">{{$t('register_email.resend')}}</ins></p>
					<p>2.{{$t('register_email.checkJunkMail')}}</p>-->
				</div>
        <div class="return"><button class="returnButton" @click="returnButton()">{{$t('common.returnButton')}}</button></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'register_email',
		data() {
			return {

			}
		},
		methods: {
			resendMail: function() {
				this.$api.post("/register/sendCheckEmail", {
					"activatePurpose": this.$route.query.activatePurpose,
					"email": this.$route.query.email,
					"domainName": window.location.host
				}).then(
					() => {
						this.$el_alert_type(window.vm.$i18n.t('js.sendSuccess'), 'success');
					}
				)
			},
      returnButton:function (){
        //返回主页
        this.$router.push("/");
        //刷新页面
        window.location.reload();
      }

    },
		mounted() {
			//获取设备屏幕的高度
			const h = document.body.clientHeight
      		this.$refs.middle_page.style.minHeight = h + "px";
		}
	}
</script>

<style scoped="scoped">
	.r_email_page {
	
	}

	.r_email_page .r_email_page_filter {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
    	z-index: 99;
		background-color: rgba(0, 0, 0, .5);
	}

	.r_email_content {
		
		position: relative;
		margin-top:10px
	}

	.r_email_box {
		width: 540px;
		min-height: 170px;
		padding: 25px;
		margin: 0 auto;
		background-color: #fff;
		border-radius: 20px;
		position: relative;
		z-index: 1000;
	}

	.r_email_box .logo_font p {
		line-height: 28px;
		text-align: center;
		font-size: 21px;
		color: #0071c5;
		margin-bottom: 20px;
	}

	.r_email_box .logo_font p span {
		font-size: 21px;
		color: #FF5252 !important;
	}

	.r_email_box .email_img {
		width: 80px;
		float:left
	}

	.r_email_box .email_img img {
		width: 60px;
		height: 40px;
		margin: 0px auto;
	}

	.email_right {
		width: calc(100% - 80px);
		float: right;
	}

	.email_right p {
		color: #000;
		text-align: left;
		font-family: source-han-sans-simplified-c, sans-serif;
		font-weight: 200;
		font-style: normal;
		padding:0 10px
	}

	.email_right p:first-child {
		font-size: 16px;
	}

	.email_right p:nth-child(2) {
		margin-top: 20px;
		font-size: 14px
	}
    
	.email_right button {
		margin-top: 30px;
		padding: 5px 20px;
		border-radius: 20px;
		border: 1px #fff solid;
		font-size: 14px;
		color: #0071c5;
		margin-bottom: 30px;
		background-color: unset;
	}

	.email_right button:hover {
		color: #000;
		background-color: #fff;
	}

	.email_right p:nth-child(4) {
		border-top: 1px rgba(153, 153, 151, 1) solid;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
	}

	.email_right p:nth-child(5),
	.email_right p:nth-child(6) {
		height: 20px;
		line-height: 20px;
		font-size: 12px;
	}
	.return{width:100%;display: flex;align-items: center;justify-content: center;}
  .returnButton {
    width: 80px;
    padding: 6px 10px;
    font-size: 14px;
    color: #fff;
    border: 1px #fff solid;
    background: #0071c5;
    border-radius: 20px;
    margin: 0 auto;
    font-weight: 200;
    font-style: normal;
	margin-top:20px
    
  }

 .returnButton:hover {
    color: #fff;
    background: #2696ff;
    transition: 0.5s ease;
  }
/* @media (max-width: 834px) {
	.r_email_content{width:100%!important}
	.r_email_page{min-width: 100%!important;}
}
@media (max-width: 480px) {
	.vn .r_email_page{min-width:100%!important}
    .r_email_content{width:100%!important;padding-top:80px!important}
    .r_email_box{width:96%!important;box-sizing:border-box;padding: 40px 10px!important;}
    .r_email_page{min-width: 100%!important;}
} */
</style>



// WEBPACK FOOTER //
// src/views/index/register_email.vue